// Lucide icon: minus (https://lucide.dev/icons/minus)
import { Minus } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconMinus = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Minus />
    </IconComponentStyled>
  )
}
